import React, { SFC } from 'react';
import Button from '@material-ui/core/Button';
import Translate from 'components/Translate';
import { SvgIcon } from 'components/SvgIcon';

interface IProps {
  message: string;
  code: string;
  idleState: () => void;
}

// tslint:disable-next-line:variable-name
export const BankslipPaymentError: SFC<IProps> = (props: IProps) => {
  const { message, code, idleState } = props;

  return (
    <div className="paymentErrorMessage">
      <div className="paymentErrorIcon">
        <SvgIcon name="banksliptError" />
      </div>
      <div className="defaultMessage">
        <Translate term={'Algo não está certo...'} />
      </div>
      <div className="errorMessage">
        <Translate term={message} />
      </div>
      <div className="helper">
        <div className="title">
          <Translate term={'O que você pode fazer?'} />
        </div>
        <div className="description">
          <ul>
            <li>
              <Translate term={'Revise as informações que você digitou.'} />
            </li>
            <li>
              <Translate term={'Escolher outro meio de pagamento pode resolver.'} />
            </li>
          </ul>
        </div>
      </div>
      <Button
        id="error-modal-button"
        size="large"
        onClick={idleState}
        classes={{
          label: 'paymentButtonLabel'
        }}
        color="primary"
        className="paymentErrorButton theme-button"
      >
        <Translate term={'Ok, Entendi'} />
      </Button>
      <div className="code">
        <Translate term={code} />
      </div>
    </div>
  );
};
